import icons from "helpers/icons";
import scss from "./AddToCardButton.module.scss";
import LoadingWrapper from "../../Loading/LoadingWrapper";
import { useTranslation } from "react-i18next";
import { isPurchaseAllowed } from "../../../helpers/product";

const AddToCartButton = ({ onClick, type = "button", short = true, iconOnly = false, className, product, productVariant, location, loading, translateKey }) => {
    const { t } = useTranslation();

    const item = productVariant ?? product;
    const can_purchase = item?.inventory?.inventory_defined && item?.price?.price_defined && isPurchaseAllowed(item?.behaviours?.cart);
    const buttonText = can_purchase ? t(`${translateKey}-${iconOnly ? "cart_long" : short ? "cart_short" : "cart_long"}`) : t(`${translateKey}-contact_link`);

    return (
        <>
            <button disabled={loading ? true : false} aria-label={iconOnly ? buttonText : undefined} style={{ zIndex: `1` }} className={`btn-basic relative btn-basic-secondary ${scss.button} ${iconOnly ? scss.iconOnly : ""} ${className}`} type={type} onClick={onClick}>
                <LoadingWrapper isLoading={loading} type="spin" size={20} color={"#fff"} className={loading ? `${scss.loading}` : `${scss.wrapper} ${scss.wrappernopadding}`}></LoadingWrapper>
                <div className={loading ? scss.loading2 : ``}>
                    {!can_purchase && <svg className={scss.inquiryIcon} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="m21 3-6.5 18-4-7.5L3 9.5 21 3ZM21 3 10.5 13.5" /></svg>}
                    {!iconOnly && <span>{buttonText}</span>}
                    {can_purchase && <img src={icons.cart} alt="" />}
                </div>
            </button>
        </>
    );
};

export default AddToCartButton;
